import { IUserBase } from '../../models/users';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateUserAssignmentProps {
  categoryId?: string;
  cpf: string;
  featureGroupKey: string;
  hostId?: string;
}

export const createUserAssignmentsService = async ({
  categoryId,
  cpf,
  featureGroupKey,
  hostId,
}: ICreateUserAssignmentProps): Promise<IUserBase> => {
  const { data } = await jhsfBookingsApi.post<IUserBase>('/users/assignments', {
    categoryId,
    cpf,
    featureGroupKey,
    hostId,
  });

  return data;
};
